import {addMarker, addToBounds} from './map';

const debounce = require('lodash.debounce');

export default ($container) => {
    const debouncedChange = debounce(function() {
        if ($(this).is('[name="q"]') && $(this).val().length === 0) {
            $(this).closest('form').find('[name="coordinates"]').val('');
        }
        $(this).trigger('change');
    }, 1000);

    // Auto-submit on any input changes
    $('.js-store-search', $container).each(function() {
        const $form = $(this);
        if ($('button[type="submit"]', $form).length === 0) {
            $(':input', $form).on('change', function() {
                $form.trigger('submit');
            });

            $(':input[type="text"]', $form).on('keyup', debouncedChange);
        }
    });

    $('.js-store', $container).each(function() {
        const $store  = $(this);
        const $target = $($store.data('target'));
        if ($target.length === 0) {
            return;
        }

        const data = $store.data('store');
        if (!(data instanceof Object) || !data.hasOwnProperty('coordinates')) {
            return;
        }
        addMarker($target, data.coordinates, data.config || {}, $store);
        if (data.hasOwnProperty('in_bounds') && data.in_bounds) {
            addToBounds($target, data.coordinates);
        }

        // Only go to detail page through info window
        if (data.config.hasOwnProperty('window')) {
            $store.find('a[href^="/winkels/"]').on('click', e => {
                if ($store.data('marker')) {
                    e.preventDefault();
                }
            });
            $store.on('click', () => {
                let marker = $store.data('marker');
                if (marker instanceof google.maps.Marker) {
                    new google.maps.event.trigger(marker, 'click');
                }
            });
        }
    });
}
